const initialState = {
    countries: [],
    error: null,
    isWorking: false,
}

export default (state = initialState, { type, payload = {} }) => {
    switch (type) {
        case 'COUNTRIES_FETCH##REQUEST':
            return {
                ...state,
                error: null,
                isWorking: true,
            }
        case 'COUNTRIES_FETCH##FAILURE':
            return {
                ...state,
                error: (payload.response || {}).msg,
                isWorking: false,
            }
        case 'COUNTRIES_FETCH##SUCCESS':
            return {
                ...state,
                isWorking: false,
                countries: (payload || []).map(({ code, name }) => ({
                    value: code,
                    name,
                })),
            }
        default:
            return state
    }
}
